import moment from 'moment-timezone'

// Helper functions
export const getIsLate = (eta, scheduled) => {
  const amountLate = moment.duration(eta.diff(scheduled))
  if (amountLate.asSeconds() >= 1 && amountLate.asMinutes() <= 30) {
    return 'warning'
  }
  if (amountLate.asMinutes() > 30) {
    return 'late'
  }
  return false
}

export const getLateDuration = (eta, scheduled) => {
  const amountLate = moment.duration(eta.diff(scheduled))
  const lateDuration = moment.duration(amountLate).humanize()
  const firstChar = lateDuration[0]
  if (/[a-z]/.test(firstChar)) {
    // eg, "a month late" becomes "A month late"
    return firstChar.toUpperCase() + lateDuration.slice(1)
  }
  return lateDuration
}

const STATUS_OPTIONS = (option, type) => {
  const options = {
    not_tracking: { isTracking: false, text: 'Not tracking', color: 'dark' },
    not_tracking_required: {
      isTracking: false,
      text: 'Not tracking \u2022 Tracking Required',
      color: 'error',
    },
    tracking: { isTracking: true, text: `Currently Tracking via ${type}`, color: 'info' },
    was_tracking: { isTracking: false, text: `Was tracking via ${type}`, color: 'warning' },
  }
  return options[option]
}

// 'Tracking' - pinged in the past 2 hours
const TRACKING_LAST_PING_HOURS = 2
// 'Was Tracking' - between 2 hours to 7 days ago
const WAS_TRACKING_LAST_PING_HOURS = 168

export const getTrackingProperties = (timestamp, timezone, type, trackingRequired) => {
  if (!(timezone && timestamp)) {
    if (trackingRequired) return STATUS_OPTIONS('not_tracking_required')
    return STATUS_OPTIONS('not_tracking')
  }
  const dateTime = moment.tz(timestamp, timezone)
  const now = moment.tz(timezone)
  const hoursAgo = now.diff(dateTime, 'hours', true)
  if (hoursAgo <= TRACKING_LAST_PING_HOURS) return STATUS_OPTIONS('tracking', type)
  // Shippers & Carriers only see Tracking or Not Tracking
  if (hoursAgo <= WAS_TRACKING_LAST_PING_HOURS) return STATUS_OPTIONS('was_tracking', type)
  if (trackingRequired) return STATUS_OPTIONS('not_tracking_required')
  return STATUS_OPTIONS('not_tracking')
}
